import React, { useEffect, useMemo, useRef } from "react"
import InsightsView from "../InsightsView/"

import "./styles.scss"
import { factors } from "../DataLoader"
import CountryCardOverall from "./CountryCardOverall"
import CountryCardRanks from "./CountryCardRanks"
import CountryCardFactors from "./CountryCardFactors"
import CountryCardCOT from "./CountryCardCOT"
import DataLoader from "../DataLoader"
//import { factorImages } from "../images/factor_icons/factorImages"
import useDimensions from "react-use-dimensions"
import Map from "../Map"
import { useSmallWidthMode } from "../utils/smallWidthMode"
import ReactMarkdown from "react-markdown"
import { Helmet } from "react-helmet"
const links = ["Overall", "Change Over Time", "Rank", "Sub-Factors"]
function CountryInsights(props) {
  const [scrollyRef, scrollyContainerDimensions, scrollNode] = useDimensions()
  const [defaultMapRef, defaultMapDimensions] = useDimensions()
  const { selectedCountry, selectedYear, selectedFactor } = props
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const inSmallWidthMode = useSmallWidthMode()
  const factorSelected = selectedFactor !== ""
  const factorIndex = factorSelected ? factors.indexOf(selectedFactor) : -1

  const selectedFactorScoreKey = factorSelected
    ? `Factor ${factorIndex + 1}: ${selectedFactor}`
    : "overall"

  const countryData = DataLoader.dataByYear[selectedYear].countries.find(
    (country) => country.Country === selectedCountry,
  )

  const currentYearData = DataLoader.dataByYear[selectedYear]
  const mapData = useMemo(
    () =>
      currentYearData.countries.map((c) => ({
        code: c["Country Code"],
        value: c[selectedFactorScoreKey],
        originalDatum: c,
        scoreKey: selectedFactorScoreKey,
      })),
    [currentYearData, selectedFactorScoreKey],
  )

  const previousSelectedFactor = useRef()
  useEffect(() => {
    if (previousSelectedFactor.current !== selectedFactor) {
      const scrollDomNode = inSmallWidthMode
        ? document.documentElement
        : scrollNode
      if (scrollDomNode) {
        scrollDomNode.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
    }
    previousSelectedFactor.current = selectedFactor
  }, [selectedFactor, inSmallWidthMode, scrollNode])

  if (!countryData) {
    let message = "Please select a country to view insights"
    if (selectedCountry !== "") {
      message = `No data exists for ${selectedCountry} in ${selectedYear}, try selecting a different country or year.`
    }
    const selectCountry = (country) => {
      return () => {
        props.updateUrl("country")(country)
      }
    }
    let mapWidth = defaultMapDimensions.width
    let map = null
    if (mapWidth) {
      const mapHeight = inSmallWidthMode ? mapWidth / 2 : 400
      map = (
        <Map
          id="countryInsightsDefault"
          data={mapData}
          width={mapWidth}
          height={mapHeight}
          animate={false}
          gotoCountryPage={selectCountry}
          tooltipEnabled={true}
          tooltipMessage={null}
        />
      )
    }
    return (
      <div className="CountryInsights noData">
        <Helmet>
          <title>WJP Rule of Law Index | Country Insights</title>
          <meta
            name="description"
            content={`Explore the WJP Rule of Law Index`}
          />
        </Helmet>
        <div className="message">{message}</div>
        <div ref={defaultMapRef} style={{ width: "100%" }}>
          {map}
        </div>
      </div>
    )
  }
  const scrollHeight =
    window.innerHeight -
    (scrollyContainerDimensions.y ? scrollyContainerDimensions.y : 0)
  const scrollIntoView = (link) => {
    return (event) => {
      document
        .querySelector(`a[name=${link}]`)
        .scrollIntoView({ behavior: "smooth" })
      event.preventDefault()
    }
  }

  let factorDescription = null
  if (factorSelected) {
    const textKey = `Factor ${factorIndex + 1} Description`
    factorDescription = DataLoader.getCopy(textKey)
  }

  return (
    <div className="CountryInsights">
      <Helmet>
        <title>
          WJP Rule of Law Index |{" "}
          {selectedCountry ? selectedCountry : "Country"} Insights
        </title>
        <meta
          name="description"
          content={`Explore the ${selectedCountry} WJP Rule of Law Index`}
        />
      </Helmet>
      <div className="countryName">
        <span className="countryLabel fontTitle">{selectedCountry}</span>
        {/* <div className='right'>
          <a download href={pdfUrl} className='downloadPdf fontCaps'>
            <span><span>Download PDF</span></span> <img src={pdfIcon} alt='download pdf' />
          </a>
        </div> */}
      </div>
      <div className="regionAndIncome">
        <div className="regionLabel label fontCaps">Region</div>
        <div className="regionValue value">{countryData.Region}</div>
        <br />
        <div className="incomeLabel label fontCaps">
          {inSmallWidthMode ? "Income" : "Income Group"}
        </div>
        <div className="incomeValue value">{countryData["Income Group"]}</div>
      </div>
      <div className="sectionNav fontCaps">
        {links.map((link) => {
          const linkAnchor = link.toLowerCase().replace(/ /g, "")
          return (
            <a
              href={`#${linkAnchor}`}
              key={link}
              onClick={scrollIntoView(linkAnchor)}
            >
              {link}
              <svg
                id="arrow--down-right"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
              >
                <path
                  id="Path_29723"
                  data-name="Path 29723"
                  d="M10,26V24H22.59L6,7.41,7.41,6,24,22.59V10h2V26Z"
                  fill="#fff"
                ></path>
                <rect
                  id="_Transparent_Rectangle_"
                  data-name="<Transparent Rectangle>"
                  width="32"
                  height="32"
                  fill="none"
                ></rect>
              </svg>
            </a>
          )
        })}
      </div>
      <div
        className="scrolly"
        ref={scrollyRef}
        style={{ height: scrollHeight }}
      >
        {factorSelected ? (
          <div className="factorInfo">
            <div className="factorTitle fontTitle">{selectedFactor}</div>
            <div className="factorDescription">
              <ReactMarkdown>{factorDescription}</ReactMarkdown>
            </div>
          </div>
        ) : null}

        <CountryCardOverall
          scoreKey={selectedFactorScoreKey}
          countryData={countryData}
          factorIndex={factorIndex}
          factorSelected={factorSelected}
          selectedFactor={selectedFactor}
          selectedCountry={selectedCountry}
          selectedYear={selectedYear}
        />
        <CountryCardCOT
          scoreKey={selectedFactorScoreKey}
          countryData={countryData}
          factorIndex={factorIndex}
          factorSelected={factorSelected}
          selectedFactor={selectedFactor}
          selectedCountry={selectedCountry}
          selectedYear={selectedYear}
        />
        <CountryCardRanks
          scoreKey={selectedFactorScoreKey}
          countryData={countryData}
          factorIndex={factorIndex}
          factorSelected={factorSelected}
          selectedFactor={selectedFactor}
          selectedCountry={selectedCountry}
          selectedYear={selectedYear}
          gotoCountryPage={props.gotoCountryPage}
        />
        <CountryCardFactors
          countryData={countryData}
          factorIndex={factorIndex}
          factorSelected={factorSelected}
          selectedFactor={selectedFactor}
          selectedCountry={selectedCountry}
          selectedYear={selectedYear}
          updateUrl={props.updateUrl}
        />
        {/* <CountryCardPlaceholder title="Resources" className='resources'>
          <div className='resources'>
            {resources.map(resource => {
              return <a key={resource.url} href={resource.url} target="_blank" rel='noopener noreferrer'>{resource.text}</a>
            })}
          </div>
        </CountryCardPlaceholder> */}
      </div>
    </div>
  )
}

export default function CountryInsightsControls(props) {
  return (
    <InsightsView {...props}>
      <CountryInsights />
    </InsightsView>
  )
}
